module.exports = __webpack_public_path__ + "static/about-img-a18b61df46008e6fb74176f542a72438.jpg";